export function chDisplayEmployeeRole(passed_role){

	let toReturn = "No Role Specified";

	if (passed_role == "employee") toReturn = "Crew Member";
	if (passed_role == "admin") toReturn = "Office";
	if (passed_role == "crewleader") toReturn = "Crew Leader";
	if (passed_role == "scheduler") toReturn = "Scheduler";

	return toReturn;
}